<!-- Added by Tishya for POA EDIS -->
<div class="ClsTransactionOTPModel p-0 ModalNPS" appDisabledRightClick>
  <div class="modal-dialog">
    <div class="modal-content AlertModalContentCls MainBgOtp">
      <div class="modal-body p-0">
        <div class="MainBg">
          <div class="MainInnerFormWithoutFlex" style="background-color: transparent;">
            <div class="OTPOuter BoxShadow text-center">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="CloseMainModal()">
                <span aria-hidden="true">&times;</span>
              </button>
              <div class="head">TPIN Transaction</div>
              <div class="text-left PaddingBottom_Mob" style="line-height: 1.5rem;">
                <strong>POA not available for
                  the client. Authorize with eDIS/TPIN required.</strong>
                <br>

                You will be redirect to CDSL portal to complete the authorization.
                <br>
                Note: Authentication would be taken on units under the ISIN as per process and would be valid for one
                day.
              </div>
              <div class="modal-footer" style="justify-content:center"> 
                <form id="postForm" [action]="verifydis" method="POST" style="display: none;" #postForm="ngForm"
                  (ngSubmit)="onSubmit(postForm)">
                  <input type="hidden" name="DPId" value="{{dpId}}" />
                  <input type="hidden" name="ReqId" value="{{reqId}}" />
                  <input type="hidden" name="Version" id="Version" value="{{version}}">
                  <input type="hidden" name="TransDtls"
                    value="{{trndtls}}"/>
                </form>
                <button type="button" class="btn btn-primary text-center Margin_Mob" data-dismiss="modal" routerLinkActive="active"
                  (click)="redirectToSubmit()">
                  Proceed with TPIN
                </button>
                <br>
                <div>
                  <strong>Don't remember your CDSL TPIN? <span><a href="{{tpingenerateurl}}" class="text-blue"
                        target="_blank">Click
                        here</a></span> to generate now.</strong>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
<!-- Added by Tishya for POA EDIS -->